<template>
    <div>
        <h3 class="text-center mb-8 mt-8 text-uppercase">Laporan Indikator Mutu {{ model.unit ? model.unit.name : '' }}</h3>
        <table class="table">
            <tr>
                <th scope="col" width="200">Unit</th>
                <td>{{ model.unit ? model.unit.name : '-' }}</td>
            </tr>
            <tr>
                <th scope="col" width="200">Terdiri dari</th>
                <td>{{ unitNames }}</td>
            </tr>
            <tr>
                <th scope="col">Bulan</th>
                <td>{{ month }} {{ model.year }}</td>
            </tr>
            <tr>
                <th scope="col">Deskripsi</th>
                <td>{{ model.description }}</td>
            </tr>
        </table>

        <div class="card-body p-4 table-responsive">
            <table class="table table-bordered table-sm table-fixed">
                <thead class="text-uppercase text-center valign-middle">
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col" class="width-200">Indikator</th>
                        <th scope="col" class="width-100">Target Indikator</th>
                        <th scope="col" colspan="2">Data yang dilaporkan</th>
                        <th scope="col" :colspan="(unitChildren.length+1)*2">Capaian</th>
                        <th scope="col" class="width-100">Ket/Analisa</th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <!-- Data yang dilaporkan -->
                        <th scope="col"></th>
                        <th scope="col" class="width-200"></th>
                        <!-- Rekapitulasi -->
                        <template v-for="(unitChild, unitKey) in unitChildren">
                            <th scope="col" class="width-100" colspan="2" :key="unitKey">{{ unitChild.name }}</th>
                        </template>
                        <th scope="col" class="width-80" colspan="2">Total</th>
                        <th scope="col" class="width-80"></th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <!-- Data yang dilaporkan -->
                        <th scope="col"></th>
                        <th scope="col" class="width-200"></th>
                        <!-- Rekapitulasi -->
                        <template v-for="(unitChild, unitKey) in unitChildren">
                            <th scope="col" class="width-80" :key="`number-${unitKey}`">Angka</th>
                            <th scope="col" class="width-80" :key="`percentage-${unitKey}`">Prosentase</th>
                        </template>
                        <th scope="col" class="width-80">Angka</th>
                        <th scope="col" class="width-80">Prosentase</th>
                        <th scope="col" class="width-80"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, key) in items">
                    <tr class="valign-middle" :key="`item-${key}`">
                        <td :rowspan="item.report_indicator_labels.length+1">{{ key+1 }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.indicator ? item.indicator.name : '-' }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.target_indicator_label }}</td>
                    </tr>
                    <tr class="valign-middle" :key="`detail-${key}-${detailKey}`" v-for="(detail, detailKey) in item.report_indicator_labels">
                        <!-- Data yang dilaporkan -->
                        <td class="text-center">{{ detailKey+1 }}</td>
                        <td>{{ detail.name }}</td>
                        <!-- Rekapitulasi -->
                        <template v-for="(unitChild, unitKey) in unitChildren">
                            <td class="text-center" :key="`${key}-${detailKey}-${unitKey}`">
                                {{ values[key][detailKey][unitKey] }}
                            </td>
                            <th :key="`sum-${key}-${unitKey}`" v-if="detailKey == 0" scope="col" class="width-80 text-center" :rowspan="item.report_indicator_labels.length">
                                {{ resultLabels[key][unitKey] }}
                            </th>
                        </template>
                        <td scope="col" class="text-center">{{ sum(values[key][detailKey]) }}</td>
                        <th scope="col" class="text-center" rowspan="2" v-if="detailKey == 0">{{ totalResults[key] }}</th>
                        <th scope="col" class="text-center"></th>
                    </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ReportRecapMonthlyParentView',
        props: {
            model: {
                type: Object,
                default: () => null
            },
            inputValues: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            months: {
                type: Array,
                default: () => []
            },
            monthKey: Number,
            unitChildren: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                loading: false,
                values: [],
                resultLabels: [],
                totalResults: [],
            }
        },
        computed: {
            unitNames() {
                return this.unitChildren.map((el) => el.name).join(', ')
            },
            month() {
                return this.months[this.monthKey]
            }
        },
        created() {
            const { monthKey } = this
            let resultLabels = [],
                totalResults = []
            this.items.map((item, key) => {
                let values = []
                item.report_indicator_labels.map((detail, detailKey) => {
                    let units = []
                    this.unitChildren.map((unitChild, unitKey) => {
                        const inputValue = this.inputValues.find((val) =>
                            val.unit_id == unitChild.id &&
                            val.indicator_id == item.indicator_id &&
                            val.report_indicator_id == detail.report_indicator_id &&
                            val.input_year == this.model.year &&
                            val.input_month == monthKey + 1)
                        units[unitKey] = inputValue ? inputValue.value : ''
                    })
                    values[detailKey] = units
                })
                this.values.push(values)

                let resultUnits = []
                this.unitChildren.map((unitChild, unitKey) => {
                    resultUnits[unitKey] = null
                    if (item.result_formula) {
                        let formula = `${item.result_formula}*100`
                        values.map((value, i) => {
                            const alphabet = this.alphabet(i)
                            let val = value[unitKey] ? value[unitKey] : 0
                            formula = formula.replace(`[${alphabet}]`, val)
                        })
                        resultUnits[unitKey] = this.normalizeEval(formula)
                    }
                })
                resultLabels[key] = resultUnits

                /** Total Keseluruhan */
                totalResults[key] = null
                if (item.result_formula) {
                    let formulaTotal = `${item.result_formula}*100`
                    item.report_indicator_labels.map((detail, detailKey) => {
                        const alphabet = this.alphabet(detailKey)
                        let total = values[detailKey].length > 0 ? this.sum(values[detailKey]) : 0
                        formulaTotal = formulaTotal.replace(`[${alphabet}]`, total)
                    })
                    totalResults[key] = this.normalizeEval(formulaTotal)
                }
            })

            this.resultLabels = resultLabels // Hasil per Indikator
            this.totalResults = totalResults
        }
    }
</script>
